import React from 'react';
import { useEventHandler } from 'hook/event.hook';
import FeaturedAdView from 'partial/FeaturedAd/FeaturedAdView';
import { useFeaturedAd } from 'partial/FeaturedAd/hooks/FeaturedAd.hook';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { FEATURED_AD } from 'types/morph.pagePosition.constants';

const FeaturedAdController = props => {
  const { location, position, hideAd } = props;
  const eventHandler = useEventHandler();
  const { featuredAdOffer } = useFeaturedAd(location, position, hideAd);
  const finalFeaturedAd = props.featuredAd ? props.featuredAd : featuredAdOffer;

  const trackingAttributes = getViewModuleTrackingAttributes({
    pagePosition: FEATURED_AD,
    modulePosition: props.modulePosition,
    vertical: finalFeaturedAd?.vertical,
  });

  useViewModule(trackingAttributes, finalFeaturedAd !== null);
  const seenModuleTracking = useSeenModulePixel(trackingAttributes);

  // this is not a good way to handle feature ads , will be creating spike to take this out , and just use feature ads in container manager.
  if (!finalFeaturedAd) {
    return null;
  } else {
    return (
      <>
        {seenModuleTracking}
        <FeaturedAdView
          {...props}
          featuredAdOffer={finalFeaturedAd}
          eventHandler={eventHandler}
        />
      </>
    );
  }
};

export default FeaturedAdController;
